import { toast } from 'sonner';
import { PS } from '../theme';

const base = { fontFamily: PS.fontUI };

export const notify = (msg, opts = {}) => toast(msg, { style: base, ...opts });
export const notifySuccess = (msg, opts = {}) => toast.success(msg, { style: base, ...opts });
export const notifyError = (msg, opts = {}) => toast.error(msg, { style: base, ...opts });
export const notifyInfo = (msg, opts = {}) => toast(msg, { style: base, icon: 'ℹ️', ...opts });

// Lightweight confirm replacement: a toast with a confirm action button.
export function confirmToast(message, { confirmLabel = 'ยืนยัน', onConfirm, description } = {}) {
  toast(message, {
    description,
    duration: 10000,
    style: base,
    action: { label: confirmLabel, onClick: () => onConfirm?.() },
    cancel: { label: 'ยกเลิก', onClick: () => {} },
  });
}

export { toast };
